import { DayjsSchema, sortOrderType } from '@/utils';
import { z } from 'zod';
import { MINISTRY_CODE_LENGTH } from '../utils';

export const MinistryModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z.string().min(1).max(MINISTRY_CODE_LENGTH),
  name: z.string().min(1),
  startDate: z.string().date().nullable(),
  endDate: z.string().date().nullable(),
});

export const MinistriesModel = MinistryModel.array();

export const MinistryFormSchema = MinistryModel.pick({
  code: true,
}).extend({
  name: MinistryModel.shape.name.max(100),
  period: DayjsSchema().nullable().array().length(2).nullish(),
});

export const UpsertMinistryRequestSchema = MinistryModel.pick({
  name: true,
  code: true,
}).extend({
  startDate: MinistryModel.shape.startDate.nullish(),
  endDate: MinistryModel.shape.endDate.nullish(),
});

export const UpdateMinistrySortOrderParamsSchema = MinistryModel.pick({
  id: true,
})
  .extend({
    sortOrder: sortOrderType,
  })
  .array();
